// File: ListSimulator.js
import React, { useState, useEffect } from "react";
import { Loader, Pagination } from "semantic-ui-react";
import { size, map } from "lodash";
import { SimulatorItem } from "../SimulatorItem/SimulatorItem";
import { simulatorApi } from "../../../../api";
import { useAuth } from "../../../../hooks";
import "./ListSimulator.scss";

export function ListSimulators({ reload, onReload, dense = true }) {
  const [simulators, setSimulators] = useState(false);
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState(1);
  const { accessToken } = useAuth();

  useEffect(() => {
    (async () => {
      try {
        const response = await simulatorApi.getSimulators(
          { page, limit: 24 }, // más elementos por página para 8 por fila
          accessToken,
        );
        setSimulators(response.simulators.docs);
        setPagination({
          limit: response.simulators.limit,
          page: response.simulators.page,
          total: response.simulators.totalPages,
          totalDocs: response.simulators.totalDocs,
        });
      } catch (error) {
        console.error(error);
      }
    })();
  }, [page, reload, accessToken]);

  const changePage = (_e, data) => setPage(data.activePage);

  if (!simulators) return <Loader active inline="centered" />;
  if (size(simulators) === 0) return <h2>No hay simuladores</h2>;

  return (
    <div className={`list-simulators ${dense ? "list-simulators--dense" : ""}`}>
      <div className="list-simulators__grid" role="list">
        {map(simulators, (sim) => (
          <div key={sim._id} className="list-simulators__cell" role="listitem">
            <SimulatorItem simulator={sim} onReload={onReload} />
          </div>
        ))}
      </div>

      <div className="list-simulators__pagination">
        <Pagination
          totalPages={pagination.total}
          defaultActivePage={pagination.page}
          ellipsisItem={null}
          firstItem={null}
          lastItem={null}
          onPageChange={changePage}
        />
      </div>
    </div>
  );
}
